var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVeryGoodFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_radial_7983_3226)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#C28000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7275 23.0586C27.3934 26.4186 24.1486 28.8233 20.311 28.8233C16.4734 28.8233 13.2122 26.4186 11.8945 23.0586H28.7275Z",
    fill: "#C28000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3211 13.3094C10.5727 14.0578 10.5727 15.2712 11.3211 16.0196L14.8015 19.5L14.8284 19.473L14.8554 19.5L18.3358 16.0196C19.0842 15.2712 19.0842 14.0578 18.3358 13.3094C17.5874 12.5609 16.374 12.5609 15.6256 13.3094L14.8284 14.1065L14.0313 13.3094C13.2829 12.5609 12.0695 12.5609 11.3211 13.3094Z",
    fill: "#FF3636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9461 13.3094C21.1977 14.0578 21.1977 15.2712 21.9461 16.0196L25.4265 19.5L25.4534 19.473L25.4804 19.5L28.9608 16.0196C29.7092 15.2712 29.7092 14.0578 28.9608 13.3094C28.2124 12.5609 26.999 12.5609 26.2506 13.3094L25.4534 14.1065L24.6563 13.3094C23.9079 12.5609 22.6945 12.5609 21.9461 13.3094Z",
    fill: "#FF3636"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7983_3226",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 10) rotate(82.3332) scale(26.2345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579521,
    stopColor: "#FFE83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE83B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVeryGoodFill);
export default __webpack_public_path__ + "static/media/IconVeryGoodFill.95567edb08bcca477956de9e2b4947e7.svg";
export { ForwardRef as ReactComponent };